import { SanityImageSource } from "@sanity/image-url/lib/types/types";
import groq from "groq";
import type * as Schema from "./schema";

export type Person = Pick<Schema.Person, "name" | "title" | "annotation"> & {
  image?: SanityImageSource;
};

export const personFields: string = groq`
  name,
  title,
  image
 `;
